<template>

        <svg xmlns="http://www.w3.org/2000/svg" class="d-none">
            <symbol id="logo" viewBox="0 0 14 10">
            <g transform="translate(0,-286.24604)">
            <rect style="fill:#d64854;stroke-width:0.337895;-inkscape-stroke:none;stop-color:#000000" id="rect1268" width="10.751953" height="10.751953" x="0" y="286.246" ry="3.2823365" />
            <path style="fill:#ffffff;stroke-width:0.106066;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stop-color:#000000" d="m 9.1322656,294.31654 c -0.7430614,-0.0991 -1.3795488,-0.53361 -1.9240113,-1.02419 -0.4155721,-0.35787 -0.9288944,-0.66749 -1.4993623,-0.61995 -0.7617483,0.0317 -1.4348684,0.4512 -1.9927302,0.93982 -0.2132066,0.23756 -0.6322423,0.2755 -0.8165788,-0.0182 -0.2328077,-0.3063 -0.041939,-0.69102 0.2406161,-0.88147 0.599899,-0.52758 1.3302884,-0.9412 2.123047,-1.07996 1.0880648,-0.13506 2.0557838,0.31443 2.7943797,0.98104 0.9044408,0.70492 1.740697,0.73731 2.6943302,0.47471 0.0015,0.33835 0.01751,0.78594 -0.03498,1.11 -0.464217,0.15081 -1.0090522,0.15659 -1.4927301,0.13038 l -0.032649,-0.004 -0.059327,-0.008 z" id="path4609" />
            <path style="fill:#61cff2;stroke-width:0.0750001;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stop-color:#000000" d="M 1.0004557,291.71793 C 0.65987747,291.67146 0.32011302,291.60496 0,291.47666 v -1.17096 c 0.37336097,0.17312 0.77240034,0.36269 1.1962644,0.33958 0.7653277,0.0246 1.3944626,-0.48629 1.9921785,-0.89384 1.121556,-0.77528 2.6389073,-0.99585 3.9027499,-0.44507 0.5814221,0.24994 1.1589364,0.57048 1.5734519,1.05871 0.1794741,0.28901 0.012776,0.77247 -0.3559421,0.78795 -0.3742555,0.0381 -0.5935043,-0.33425 -0.8947917,-0.48855 -0.870829,-0.52856 -1.9934255,-0.79264 -2.8652536,-0.42056 -0.8985046,0.30368 -1.5387692,1.09737 -2.4681222,1.33457 -0.3487764,0.10846 -0.7153896,0.15599 -1.0800794,0.13944 z" id="path4648" />
            <path style="fill:#ffffff;stroke-width:0.106066;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stop-color:#000000" d="m 9.1322656,294.31654 c -0.7430614,-0.0991 -1.3795488,-0.53361 -1.9240113,-1.02419 -0.4155721,-0.35787 -0.9288944,-0.66749 -1.4993623,-0.61995 -0.7617483,0.0317 -1.4348684,0.4512 -1.9927302,0.93982 -0.2132066,0.23756 -0.6322423,0.2755 -0.8165788,-0.0182 -0.2328077,-0.3063 -0.041939,-0.69102 0.2406161,-0.88147 0.599899,-0.52758 1.3302884,-0.9412 2.123047,-1.07996 1.0880648,-0.13506 2.0557838,0.31443 2.7943797,0.98104 0.9044408,0.70492 1.740697,0.73731 2.6943302,0.47471 0.02375,0.64625 0.0421,0.68675 -0.03498,1.11 -0.464217,0.15081 -1.0090522,0.15659 -1.4927301,0.13038 l -0.032649,-0.004 -0.059327,-0.008 z" id="path8921" />
            </g>
            </symbol>
            <symbol id="flunatic" viewBox="0 0 48 10">
            <g transform="translate(0,-286.24604)">
            <g aria-label="flunatic!" transform="scale(1.0020774,0.9979269)" id="text914" style="fill:#d64854;">
            <path d="m 13.626545,290.90578 h 0.990601 v 0.85514 h -0.990601 v 3.52213 h -1.007533 v -3.52213 h -0.635001 v -0.85514 h 0.635001 v -0.4572 q 0,-0.55033 0.347133,-0.90593 0.347134,-0.3556 0.889,-0.3556 0.245534,0 0.491067,0.0931 0.254,0.0931 0.440267,0.254 l -0.296333,0.6604 q -0.0762,-0.0762 -0.194734,-0.11853 -0.110066,-0.0423 -0.237066,-0.0423 -0.186267,0 -0.313267,0.14393 -0.118534,0.14393 -0.118534,0.36407 z" id="path11456" />
            <path d="m 15.359049,289.36485 h 1.032933 v 5.9182 h -1.032933 z" id="path11458" />
            <path d="m 21.570407,290.90578 v 4.37727 h -1.032934 v -0.59267 q -0.2032,0.31327 -0.567267,0.508 -0.364067,0.18627 -0.795867,0.18627 -0.474133,0 -0.846667,-0.21167 -0.364067,-0.22013 -0.575733,-0.60113 -0.2032,-0.38947 -0.2032,-0.88053 v -2.78554 h 1.007533 v 2.58234 q 0,0.44873 0.254,0.7366 0.254,0.2794 0.660401,0.2794 0.448733,0 0.753533,-0.27094 0.313267,-0.2794 0.313267,-0.67733 v -2.65007 z" id="path11460" />
            <path d="m 25.207905,290.80418 q 0.474133,0 0.846667,0.22014 0.372533,0.21166 0.575733,0.60113 0.211667,0.381 0.211667,0.87207 v 2.78553 h -1.007534 v -2.58233 q 0,-0.44874 -0.254,-0.72814 -0.254,-0.28786 -0.6604,-0.28786 -0.448733,0 -0.762,0.2794 -0.3048,0.27093 -0.3048,0.66886 v 2.65007 h -1.032934 v -4.37727 h 1.032934 v 0.59267 q 0.2032,-0.31327 0.5588,-0.49953 0.364067,-0.19474 0.795867,-0.19474 z" id="path11462" />
            <path d="m 29.751338,290.80418 q 0.8636,0 1.363134,0.508 0.508,0.49954 0.508,1.33774 v 2.63313 h -1.007534 v -0.51647 q -0.237066,0.28787 -0.6096,0.4572 -0.372533,0.16087 -0.762,0.16087 -0.465667,0 -0.838201,-0.16933 -0.364066,-0.1778 -0.575733,-0.49107 -0.211667,-0.32173 -0.211667,-0.7366 0,-0.42333 0.237067,-0.75353 0.237067,-0.3302 0.643467,-0.51647 0.4064,-0.18627 0.897467,-0.18627 0.5842,0 1.2192,0.2286 v -0.11006 q 0,-0.4318 -0.262466,-0.7112 -0.254001,-0.28787 -0.804334,-0.28787 -0.524934,0 -1.185334,0.3302 l -0.3556,-0.71967 q 0.931334,-0.4572 1.744134,-0.4572 z m -0.2794,3.82694 q 0.397933,0 0.728134,-0.19474 0.338666,-0.19473 0.414866,-0.52493 v -0.49953 q -0.508,-0.16087 -1.0668,-0.16087 -0.397934,0 -0.668867,0.2032 -0.270933,0.19473 -0.270933,0.49953 0,0.3048 0.245533,0.49107 0.245533,0.18627 0.618067,0.18627 z" id="path11464" />
            <path d="m 35.124496,295.03752 q -0.186267,0.16086 -0.440267,0.254 -0.245533,0.0931 -0.499534,0.0931 -0.541866,0 -0.889,-0.3556 -0.338667,-0.3556 -0.338667,-0.90593 v -2.3622 h -0.635 v -0.85514 h 0.635 v -1.20227 h 0.999067 v 1.20227 h 0.990601 v 0.85514 h -0.990601 v 2.2352 q 0,0.22013 0.127,0.36406 0.127,0.14394 0.313267,0.14394 0.127,0 0.237067,-0.0423 0.118533,-0.0423 0.194733,-0.11853 z" id="path11466" />
            <path d="m 35.934124,290.90578 h 1.032934 v 4.37727 h -1.032934 z m 0.516467,-0.6604 q -0.245534,0 -0.423334,-0.1778 -0.169333,-0.1778 -0.169333,-0.41487 0,-0.23706 0.169333,-0.4064 0.1778,-0.1778 0.423334,-0.1778 0.237067,0 0.4064,0.1778 0.1778,0.16934 0.1778,0.4064 0,0.23707 -0.1778,0.41487 -0.169333,0.1778 -0.4064,0.1778 z" id="path11468" />
            <path d="m 40.223548,295.38465 q -0.626533,0 -1.1684,-0.31327 -0.5334,-0.31326 -0.855134,-0.8382 -0.321733,-0.5334 -0.321733,-1.143 0,-0.6096 0.321733,-1.13453 0.321734,-0.52493 0.863601,-0.8382 0.541866,-0.31327 1.1684,-0.31327 0.491067,0 0.9144,0.19474 0.423334,0.18626 0.745067,0.51646 l -0.694267,0.6096 q -0.1778,-0.2032 -0.440266,-0.32173 -0.262467,-0.11853 -0.533401,-0.11853 -0.3556,0 -0.6604,0.19473 -0.3048,0.18627 -0.4826,0.51647 -0.1778,0.32173 -0.1778,0.69426 0,0.381 0.1778,0.7112 0.1778,0.32174 0.4826,0.51647 0.3048,0.18627 0.6604,0.18627 0.2794,0 0.541867,-0.11854 0.270934,-0.127 0.4572,-0.33866 l 0.694267,0.60113 q -0.3302,0.34713 -0.762,0.54187 -0.4318,0.19473 -0.931334,0.19473 z" id="path11470" />
            <path d="m 42.84504,289.46645 h 1.193801 l -0.245534,3.9116 h -0.7112 z m 0.592667,5.9182 q -0.287866,0 -0.4826,-0.19473 -0.194733,-0.2032 -0.194733,-0.4826 0,-0.26247 0.194733,-0.4572 0.2032,-0.19474 0.4826,-0.19474 0.262467,0 0.4572,0.19474 0.194734,0.19473 0.194734,0.4572 0,0.2794 -0.194734,0.4826 -0.186266,0.19473 -0.4572,0.19473 z" id="path11472" />
            </g>
            <rect style="fill:#d64854;stroke-width:0.337895;-inkscape-stroke:none;stop-color:#000000" id="rect1268" width="10.751953" height="10.751953" x="0" y="286.246" ry="3.2823365" />
            <path style="fill:#ffffff;stroke-width:0.106066;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stop-color:#000000" d="m 9.1322656,294.31654 c -0.7430614,-0.0991 -1.3795488,-0.53361 -1.9240113,-1.02419 -0.4155721,-0.35787 -0.9288944,-0.66749 -1.4993623,-0.61995 -0.7617483,0.0317 -1.4348684,0.4512 -1.9927302,0.93982 -0.2132066,0.23756 -0.6322423,0.2755 -0.8165788,-0.0182 -0.2328077,-0.3063 -0.041939,-0.69102 0.2406161,-0.88147 0.599899,-0.52758 1.3302884,-0.9412 2.123047,-1.07996 1.0880648,-0.13506 2.0557838,0.31443 2.7943797,0.98104 0.9044408,0.70492 1.740697,0.73731 2.6943302,0.47471 0.0015,0.33835 0.01751,0.78594 -0.03498,1.11 -0.464217,0.15081 -1.0090522,0.15659 -1.4927301,0.13038 l -0.032649,-0.004 -0.059327,-0.008 z" id="path4609" />
            <path style="fill:#61cff2;stroke-width:0.0750001;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stop-color:#000000" d="M 1.0004557,291.71793 C 0.65987747,291.67146 0.32011302,291.60496 0,291.47666 v -1.17096 c 0.37336097,0.17312 0.77240034,0.36269 1.1962644,0.33958 0.7653277,0.0246 1.3944626,-0.48629 1.9921785,-0.89384 1.121556,-0.77528 2.6389073,-0.99585 3.9027499,-0.44507 0.5814221,0.24994 1.1589364,0.57048 1.5734519,1.05871 0.1794741,0.28901 0.012776,0.77247 -0.3559421,0.78795 -0.3742555,0.0381 -0.5935043,-0.33425 -0.8947917,-0.48855 -0.870829,-0.52856 -1.9934255,-0.79264 -2.8652536,-0.42056 -0.8985046,0.30368 -1.5387692,1.09737 -2.4681222,1.33457 -0.3487764,0.10846 -0.7153896,0.15599 -1.0800794,0.13944 z" id="path4648" />
            <path style="fill:#ffffff;stroke-width:0.106066;stroke-linecap:round;stroke-miterlimit:4;stroke-dasharray:none;stop-color:#000000" d="m 9.1322656,294.31654 c -0.7430614,-0.0991 -1.3795488,-0.53361 -1.9240113,-1.02419 -0.4155721,-0.35787 -0.9288944,-0.66749 -1.4993623,-0.61995 -0.7617483,0.0317 -1.4348684,0.4512 -1.9927302,0.93982 -0.2132066,0.23756 -0.6322423,0.2755 -0.8165788,-0.0182 -0.2328077,-0.3063 -0.041939,-0.69102 0.2406161,-0.88147 0.599899,-0.52758 1.3302884,-0.9412 2.123047,-1.07996 1.0880648,-0.13506 2.0557838,0.31443 2.7943797,0.98104 0.9044408,0.70492 1.740697,0.73731 2.6943302,0.47471 0.02375,0.64625 0.0421,0.68675 -0.03498,1.11 -0.464217,0.15081 -1.0090522,0.15659 -1.4927301,0.13038 l -0.032649,-0.004 -0.059327,-0.008 z" id="path8921" />
            </g>
            </symbol>
            <symbol id="practice" viewBox="0 0 30 24">
            <path d="M31 23H1C0.734784 23 0.48043 22.8946 0.292893 22.7071C0.105357 22.5196 0 22.2652 0 22C0 21.7348 0.105357 21.4804 0.292893 21.2929C0.48043 21.1054 0.734784 21 1 21H31C31.2652 21 31.5196 21.1054 31.7071 21.2929C31.8946 21.4804 32 21.7348 32 22C32 22.2652 31.8946 22.5196 31.7071 22.7071C31.5196 22.8946 31.2652 23 31 23Z"/>
            <path d="M31 19H30.38C28.4756 19.0044 26.6304 18.3385 25.1677 17.119C23.705 15.8995 22.7181 14.2041 22.38 12.33C21.62 8.44 19.89 1.94 16 1.94C12.11 1.94 10.31 8.45 9.62 12.33C9.27769 14.2005 8.28901 15.8912 6.82672 17.1067C5.36443 18.3222 3.52152 18.9853 1.62 18.98H1C0.734784 18.98 0.48043 18.8746 0.292893 18.6871C0.105357 18.4996 0 18.2452 0 17.98C0 17.7148 0.105357 17.4604 0.292893 17.2729C0.48043 17.0854 0.734784 16.98 1 16.98H1.6C3.02364 16.9789 4.40221 16.4808 5.49767 15.5715C6.59313 14.6623 7.33671 13.3991 7.6 12C9.01 4.12 11.9 0 15.95 0C20 0 22.88 4.16 24.28 12C24.5391 13.4028 25.2809 14.6706 26.3768 15.5838C27.4727 16.4971 28.8535 16.9981 30.28 17H31C31.2652 17 31.5196 17.1054 31.7071 17.2929C31.8946 17.4804 32 17.7348 32 18C32 18.2652 31.8946 18.5196 31.7071 18.7071C31.5196 18.8946 31.2652 19 31 19Z"/>
            </symbol>
            <symbol id="videos" viewBox="0 0 14 14">
            <path fill-rule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"/>
            </symbol>
            <symbol id="folder" viewBox="0 0 16 16">
            <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/>
            </symbol>
            <symbol id="themes" viewBox="0 0 16 16">
            <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z"/>
            </symbol>
            <symbol id="question-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
            </symbol>
            <symbol id="person-circle" viewBox="0 0 16 16">
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
            <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
            </symbol>
            <symbol id="arrow-left" viewBox="0 0 16 26">
            <path d="M15.9006 2.47758L13.5717 0.238586L0.632324 12.7618L13.5848 25.285L15.9006 23.046L5.26382 12.7618L15.9006 2.47758V2.47758Z"/>
            </symbol>
            <symbol id="arrow-right" viewBox="0 0 12 19">
            <path d="M0.552368 17.1039L2.22832 18.7798L11.6023 9.40583L2.22832 0.0318604L0.552368 1.70781L8.25039 9.40583L0.552368 17.1039V17.1039Z"/>
            </symbol>
            <symbol id="done" viewBox="0 0 16 16">
            <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
            </symbol>
            <symbol id="bug" viewBox="0 0 16 16">
            <path d="M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z"/>
            <path d="M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z"/>
            </symbol>
            <symbol id="tree" viewBox="0 0 16 16">
            <path d="M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5z"/>
            </symbol>
            <symbol id="bicycle" viewBox="0 0 16 16">
            <path d="M4 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1v.5h4.14l.386-1.158A.5.5 0 0 1 11 4h1a.5.5 0 0 1 0 1h-.64l-.311.935.807 1.29a3 3 0 1 1-.848.53l-.508-.812-2.076 3.322A.5.5 0 0 1 8 10.5H5.959a3 3 0 1 1-1.815-3.274L5 5.856V5h-.5a.5.5 0 0 1-.5-.5zm1.5 2.443-.508.814c.5.444.85 1.054.967 1.743h1.139L5.5 6.943zM8 9.057 9.598 6.5H6.402L8 9.057zM4.937 9.5a1.997 1.997 0 0 0-.487-.877l-.548.877h1.035zM3.603 8.092A2 2 0 1 0 4.937 10.5H3a.5.5 0 0 1-.424-.765l1.027-1.643zm7.947.53a2 2 0 1 0 .848-.53l1.026 1.643a.5.5 0 1 1-.848.53L11.55 8.623z"/>
            </symbol>
            <symbol id="flower" viewBox="0 0 16 16">
            <path d="M6.174 1.184a2 2 0 0 1 3.652 0A2 2 0 0 1 12.99 3.01a2 2 0 0 1 1.826 3.164 2 2 0 0 1 0 3.652 2 2 0 0 1-1.826 3.164 2 2 0 0 1-3.164 1.826 2 2 0 0 1-3.652 0A2 2 0 0 1 3.01 12.99a2 2 0 0 1-1.826-3.164 2 2 0 0 1 0-3.652A2 2 0 0 1 3.01 3.01a2 2 0 0 1 3.164-1.826zM8 1a1 1 0 0 0-.998 1.03l.01.091c.012.077.029.176.054.296.049.241.122.542.213.887.182.688.428 1.513.676 2.314L8 5.762l.045-.144c.248-.8.494-1.626.676-2.314.091-.345.164-.646.213-.887a4.997 4.997 0 0 0 .064-.386L9 2a1 1 0 0 0-1-1zM2 9l.03-.002.091-.01a4.99 4.99 0 0 0 .296-.054c.241-.049.542-.122.887-.213a60.59 60.59 0 0 0 2.314-.676L5.762 8l-.144-.045a60.59 60.59 0 0 0-2.314-.676 16.705 16.705 0 0 0-.887-.213 4.99 4.99 0 0 0-.386-.064L2 7a1 1 0 1 0 0 2zm7 5-.002-.03a5.005 5.005 0 0 0-.064-.386 16.398 16.398 0 0 0-.213-.888 60.582 60.582 0 0 0-.676-2.314L8 10.238l-.045.144c-.248.8-.494 1.626-.676 2.314-.091.345-.164.646-.213.887a4.996 4.996 0 0 0-.064.386L7 14a1 1 0 1 0 2 0zm-5.696-2.134.025-.017a5.001 5.001 0 0 0 .303-.248c.184-.164.408-.377.661-.629A60.614 60.614 0 0 0 5.96 9.23l.103-.111-.147.033a60.88 60.88 0 0 0-2.343.572c-.344.093-.64.18-.874.258a5.063 5.063 0 0 0-.367.138l-.027.014a1 1 0 1 0 1 1.732zM4.5 14.062a1 1 0 0 0 1.366-.366l.014-.027c.01-.02.021-.048.036-.084a5.09 5.09 0 0 0 .102-.283c.078-.233.165-.53.258-.874a60.6 60.6 0 0 0 .572-2.343l.033-.147-.11.102a60.848 60.848 0 0 0-1.743 1.667 17.07 17.07 0 0 0-.629.66 5.06 5.06 0 0 0-.248.304l-.017.025a1 1 0 0 0 .366 1.366zm9.196-8.196a1 1 0 0 0-1-1.732l-.025.017a4.951 4.951 0 0 0-.303.248 16.69 16.69 0 0 0-.661.629A60.72 60.72 0 0 0 10.04 6.77l-.102.111.147-.033a60.6 60.6 0 0 0 2.342-.572c.345-.093.642-.18.875-.258a4.993 4.993 0 0 0 .367-.138.53.53 0 0 0 .027-.014zM11.5 1.938a1 1 0 0 0-1.366.366l-.014.027c-.01.02-.021.048-.036.084a5.09 5.09 0 0 0-.102.283c-.078.233-.165.53-.258.875a60.62 60.62 0 0 0-.572 2.342l-.033.147.11-.102a60.848 60.848 0 0 0 1.743-1.667c.252-.253.465-.477.629-.66a5.001 5.001 0 0 0 .248-.304l.017-.025a1 1 0 0 0-.366-1.366zM14 9a1 1 0 0 0 0-2l-.03.002a4.996 4.996 0 0 0-.386.064c-.242.049-.543.122-.888.213-.688.182-1.513.428-2.314.676L10.238 8l.144.045c.8.248 1.626.494 2.314.676.345.091.646.164.887.213a4.996 4.996 0 0 0 .386.064L14 9zM1.938 4.5a1 1 0 0 0 .393 1.38l.084.035c.072.03.166.064.283.103.233.078.53.165.874.258a60.88 60.88 0 0 0 2.343.572l.147.033-.103-.111a60.584 60.584 0 0 0-1.666-1.742 16.705 16.705 0 0 0-.66-.629 4.996 4.996 0 0 0-.304-.248l-.025-.017a1 1 0 0 0-1.366.366zm2.196-1.196.017.025a4.996 4.996 0 0 0 .248.303c.164.184.377.408.629.661A60.597 60.597 0 0 0 6.77 5.96l.111.102-.033-.147a60.602 60.602 0 0 0-.572-2.342c-.093-.345-.18-.642-.258-.875a5.006 5.006 0 0 0-.138-.367l-.014-.027a1 1 0 1 0-1.732 1zm9.928 8.196a1 1 0 0 0-.366-1.366l-.027-.014a5 5 0 0 0-.367-.138c-.233-.078-.53-.165-.875-.258a60.619 60.619 0 0 0-2.342-.572l-.147-.033.102.111a60.73 60.73 0 0 0 1.667 1.742c.253.252.477.465.66.629a4.946 4.946 0 0 0 .304.248l.025.017a1 1 0 0 0 1.366-.366zm-3.928 2.196a1 1 0 0 0 1.732-1l-.017-.025a5.065 5.065 0 0 0-.248-.303 16.705 16.705 0 0 0-.629-.661A60.462 60.462 0 0 0 9.23 10.04l-.111-.102.033.147a60.6 60.6 0 0 0 .572 2.342c.093.345.18.642.258.875a4.985 4.985 0 0 0 .138.367.575.575 0 0 0 .014.027zM8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
            </symbol>
            <symbol id="robot" viewBox="0 0 16 16">
            <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"/>
            <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
            </symbol>
            <symbol id="umbrella" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 0a.5.5 0 0 1 .5.5v.514C12.625 1.238 16 4.22 16 8c0 0 0 .5-.5.5-.149 0-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394A3.166 3.166 0 0 0 13 7.5c-.638 0-1.178.213-1.564.434a3.484 3.484 0 0 0-.555.394l-.025.023-.003.003s-.204.146-.353.146-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394 3.3 3.3 0 0 0-1.064-.39V13.5H8h.5v.039l-.005.083a2.958 2.958 0 0 1-.298 1.102 2.257 2.257 0 0 1-.763.88C7.06 15.851 6.587 16 6 16s-1.061-.148-1.434-.396a2.255 2.255 0 0 1-.763-.88 2.958 2.958 0 0 1-.302-1.185v-.025l-.001-.009v-.003s0-.002.5-.002h-.5V13a.5.5 0 0 1 1 0v.506l.003.044a1.958 1.958 0 0 0 .195.726c.095.191.23.367.423.495.19.127.466.229.879.229s.689-.102.879-.229c.193-.128.328-.304.424-.495a1.958 1.958 0 0 0 .197-.77V7.544a3.3 3.3 0 0 0-1.064.39 3.482 3.482 0 0 0-.58.417l-.004.004S5.65 8.5 5.5 8.5c-.149 0-.352-.145-.352-.145l-.004-.004a3.482 3.482 0 0 0-.58-.417A3.166 3.166 0 0 0 3 7.5c-.638 0-1.177.213-1.564.434a3.482 3.482 0 0 0-.58.417l-.004.004S.65 8.5.5 8.5C0 8.5 0 8 0 8c0-3.78 3.375-6.762 7.5-6.986V.5A.5.5 0 0 1 8 0z"/>
            </symbol>
            <!-- keep the mic from figma prototype - the bootstrap one is ugly -->
            <symbol id="microphone" viewBox="0 0 40 40">
            <path d="M20.0002 23.3334C22.7668 23.3334 25.0002 21.1 25.0002 18.3334V8.33337C25.0002 5.56671 22.7668 3.33337 20.0002 3.33337C17.2335 3.33337 15.0002 5.56671 15.0002 8.33337V18.3334C15.0002 21.1 17.2335 23.3334 20.0002 23.3334ZM18.3335 8.33337C18.3335 7.41671 19.0835 6.66671 20.0002 6.66671C20.9168 6.66671 21.6668 7.41671 21.6668 8.33337V18.3334C21.6668 19.25 20.9168 20 20.0002 20C19.0835 20 18.3335 19.25 18.3335 18.3334V8.33337ZM28.3335 18.3334C28.3335 22.9334 24.6002 26.6667 20.0002 26.6667C15.4002 26.6667 11.6668 22.9334 11.6668 18.3334H8.3335C8.3335 24.2167 12.6835 29.05 18.3335 29.8667V35H21.6668V29.8667C27.3168 29.05 31.6668 24.2167 31.6668 18.3334H28.3335Z"/>
            </symbol>
            <!-- bootstrap version of mic
            <symbol id="microphone" viewBox="0 0 16 16">
            <path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z"/>
            <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/>
            </symbol>
            -->
            <symbol id="pause" viewBox="0 0 16 16">
            <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
            </symbol>
            <symbol id="stop" viewBox="0 0 16 16">
            <path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5z"/>
            </symbol>
            <symbol id="speaker" viewBox="0 0 16 16">
            <path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"/>
            <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"/>
            <path d="M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"/>
            </symbol>
            <symbol id="play" viewBox="0 0 24 16">
            <path d="M3,14C3,14 2,14 2,13C2,12 3,9 8,9C13,9 14,12 14,13C14,14 13,14 13,14L3,14ZM8,8C9.646,8 11,6.646 11,5C11,3.354 9.646,2 8,2C6.354,2 5,3.354 5,5C5,6.646 6.354,8 8,8Z" style="fill-rule:nonzero;"/>
            <g transform="matrix(0.704653,0,0,0.704653,10.9786,-0.383037)">
            <path d="M8.5,2C8.774,2 9,2.226 9,2.5L9,13.5C9,13.774 8.774,14 8.5,14C8.226,14 8,13.774 8,13.5L8,2.5C8,2.226 8.226,2 8.5,2ZM6.5,4C6.774,4 7,4.226 7,4.5L7,11.5C7,11.774 6.774,12 6.5,12C6.226,12 6,11.774 6,11.5L6,4.5C6,4.226 6.226,4 6.5,4ZM10.5,4C10.774,4 11,4.226 11,4.5L11,11.5C11,11.774 10.774,12 10.5,12C10.226,12 10,11.774 10,11.5L10,4.5C10,4.226 10.226,4 10.5,4ZM4.5,5.5C4.774,5.5 5,5.726 5,6L5,10C5,10.274 4.774,10.5 4.5,10.5C4.226,10.5 4,10.274 4,10L4,6C4,5.726 4.226,5.5 4.5,5.5ZM12.5,5.5C12.774,5.5 13,5.726 13,6L13,10C13,10.274 12.774,10.5 12.5,10.5C12.226,10.5 12,10.274 12,10L12,6C12,5.726 12.226,5.5 12.5,5.5ZM2.5,6.5C2.774,6.5 3,6.726 3,7L3,9C3,9.274 2.774,9.5 2.5,9.5C2.226,9.5 2,9.274 2,9L2,7C2,6.726 2.226,6.5 2.5,6.5ZM14.5,6.5C14.774,6.5 15,6.726 15,7L15,9C15,9.274 14.774,9.5 14.5,9.5C14.226,9.5 14,9.274 14,9L14,7C14,6.726 14.226,6.5 14.5,6.5Z"/>
            </g>
            </symbol>
            <symbol id="note" viewBox="0 0 16 16">
            <path d="M6 13c0 1.105-1.12 2-2.5 2S1 14.105 1 13c0-1.104 1.12-2 2.5-2s2.5.896 2.5 2zm9-2c0 1.105-1.12 2-2.5 2s-2.5-.895-2.5-2 1.12-2 2.5-2 2.5.895 2.5 2z"/>
            <path fill-rule="evenodd" d="M14 11V2h1v9h-1zM6 3v10H5V3h1z"/>
            <path d="M5 2.905a1 1 0 0 1 .9-.995l8-.8a1 1 0 0 1 1.1.995V3L5 4V2.905z"/>
            </symbol>
        </svg>

        <!-- success, warning, info and error messages. see prototype: demo_page.html -->

        <template v-if="messageStore">
            <div v-for="(warning, id) in messageStore.warnings" :key="id" class="kst-alert alert-warning" tabindex="-1" style="display:flex" :style="warning.decaying ? 'opacity: 0' : ''">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <span class="alert-message">
                    {{warning.text}}&thinsp;
                    <router-link v-if="warning.faqSection" :to="'/faq#' + warning.faqSection" target="_blank" rel="opener"
                        >{{$t('navigation.openFAQ')}}</router-link>
                </span>
                <button class="btn-inline" @click="clearWarning(id)"><i class="fa-solid fa-close"></i></button>
            </div>

            <div v-for="(success, id) in messageStore.successes" :key="id" class="kst-alert alert-success" tabindex="-1" style="display:flex" :style="success.decaying ? 'opacity: 0' : ''">
                <i class="fa-solid fa-circle-check"></i>
                <span class="alert-message">
                    {{success.text}}&thinsp;
                    <router-link v-if="success.faqSection" :to="'/faq#' + success.faqSection" target="_blank" rel="opener"
                        >{{$t('navigation.openFAQ')}}</router-link>
                </span>
                <button class="btn-inline" @click="clearSuccess(id)"><i class="fa-solid fa-close"></i></button>
            </div>

            <div v-for="(info, id) in messageStore.informations" :key="id" class="kst-alert" tabindex="-1" style="display:flex" :style="info.decaying ? 'opacity: 0' : ''">
                <i class="fa-solid fa-triangle-exclamation"></i>
                <span class="alert-message">
                    {{info.text}}&thinsp;
                    <router-link v-if="info.faqSection" :to="'/faq#' + info.faqSection" target="_blank" rel="opener"
                        >{{$t('navigation.openFAQ')}}</router-link>
                    <router-link v-if="info.linkTarget" :to="info.linkTarget" target="_blank" rel="opener"
                        >{{info.linkText}}</router-link>
                </span>
                <button class="btn-inline" @click="clearInformation(id)"><i class="fa-solid fa-close"></i></button>
            </div>

        </template>

        <!-- TODO: should not be a modal according to figma. -->
        <div id="alert_register" class="modal fade" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content green">
                    <div class="modal-body">
                        <div class="container-fluid">
                            <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div class="row justify-content-center">
                                <div class="col max">
                                    <p>blub bla. z.B. Wir haben dir eine Registrierungsmail geschickt. Bitte überprüfe dein E-Mail-Postfach. Schaue auch im Spam-Ordner nach.</p>
                                    <div class="row">
                                        <div class="col">
                                            <button type="submit" class="btn btn-link dark orange-border btn-sm" data-bs-target="xyz" data-bs-tag="support">Support</button>
                                            <button type="button" class="btn btn-link dark orange-border btn-sm ms-3" data-bs-dismiss="modal">OK</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <div ref="about" class="modal fade" data-bs-backdrop="static">
             <div class="modal-dialog modal-m">
                 <div class="modal-content modal-padded modal-united">
                    <div class="modal-header">
                        <h4 class="modal-title">KST-Flunatic</h4>
                    </div>

                    <div class="modal-body">
                        <p>
                        KST-Flunatic
                        </p>
                        <p>
                        version: {{version}}<br/>
                        source version: {{sourceVersion}}<br/>
                        build time: {{buildTime}}<br/>
                        server from: {{serverStartup}}<br/>
                        server version: {{serverVersion}}<br/>
                        server source version: {{serverSourceVersion}}<br/>
                        </p>

                        <p>
                            <a href="/attribution.txt">Third-party libraries</a>
                        </p>

                        <p>
                            <a href="/attribution-backend.txt">Third-party libraries (2)</a>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-around">
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <button @click="testRelogin">testRelogin</button>
        -->
                        
        <!-- based on fauchi-prototype/index.html, see 'header'
        <header>
        -->
        <header v-if="authenticated">
            <div class="kst-header fixed-top">
                <div class="container-fluid">
                    <nav>
                        <div class="d-flex flex-wrap">
                            <router-link to="/" aria-label="KST-Flunatic">
                                <span class="icon_logo"></span>
                            </router-link>

                            <ul class="nav navbar-center">
                                <template v-if="tableOfContents && management.active">
                                    <li v-for="(book, bookIndex) in tableOfContents.books" class="dropdown" v-on:keyup="clickmeIfSpaceOrEnter" @click="unlockAutoplay">
                                        <template v-if="book.active">
                                            <button class="nav-link text-white" 
                                                data-bs-toggle="dropdown" role="button" aria-expanded="false"
                                                :class="($route.params.book == (bookIndex + 1) ? 'on' : '') + (book.icon.type == 'class' ? ' svg' : '')"
                                                :aria-label="book.name"
                                                >
                                                <template v-if="book.icon.type == 'class'">
                                                    <span :class="book.icon.name"></span>
                                                </template>
                                                <template v-else>
                                                    <i class="fa-solid" :class="book.icon.name"></i>
                                                </template>
                                                <span>&nbsp;</span>
                                                <span class="d-none d-xl-inline ps-1">{{book.name}}</span>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li class="dropdown" v-for="(chapter, chapterIndex) in book.chapters">
                                                    <template v-if="chapter.active">
                                                        <button class="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false"
                                                            :class="$route.params.book == (bookIndex + 1) && $route.params.chapter == (chapterIndex + 1) ? 'active' : ''"
                                                            >{{chapter.name}}</button>
                                                        <ul class="submenu dropdown-menu">
                                                            <template v-for="(section, sectionIndex) in chapter.sections">
                                                                <li v-if="section.active">
                                                                    <router-link :to="'/therapy-' + encodeURIComponent(tableOfContents.descriptiveId) + '/book-' + (bookIndex + 1) + '/chapter-' + (chapterIndex + 1) + '/section-' + (sectionIndex + 1)" class="dropdown-item"
                                                                        :class="$route.params.book == (bookIndex + 1) && $route.params.chapter == (chapterIndex + 1) && $route.params.section == (sectionIndex + 1) ? 'active' : ''"
                                                                        v-html="sanitizeSection(section.name)">
                                                                    </router-link>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </template>
                                                </li>
                                            </ul>
                                        </template>
                                    </li>
                                </template>

                                <li v-if="tableOfContents && tableOfContents.showVideoMenu"
                                    class="dropdown" v-on:keyup="clickmeIfSpaceOrEnter">
                                    <button class="nav-link text-white" :class="$route.meta.headerMenu == 'videos' ? 'on' : ''" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                                        <i class="fa-solid fa-video"></i>
                                        <span>&nbsp;</span>
                                        <span class="d-none d-xl-inline ps-1">{{$t('menu.videos')}}</span>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li><router-link to="/video" class="dropdown-item">{{$t('menu.uploadVideo')}}</router-link></li>
                                        <li><router-link to="/videos" class="dropdown-item">{{$t('videos.myVideos')}}</router-link></li>
                                    </ul>
                                </li>
                                <li class="" v-if="landscape && freachUrl">
                                    <a :href="freachUrl" target="_blank" :aria-label="$t('navigation.openFREACH')" class="nav-link text-white suppress-target-blank-icon" role="button" aria-expanded="false">
                                        <i class="fa-solid fa-calendar-days"></i>
                                        <span>&nbsp;</span>
                                        <span class="d-none d-xl-inline ps-1" translate="no">Freach</span>
                                    </a>
                                </li>
                            </ul>

                            <ul class="nav navbar-end">
                                <li v-if="landscape">
                                    <button class="nav-link text-white" @click="toggleFullScreen" :aria-label="$t('menu.toggleFullScreen')">
                                        <i v-if="isFullScreen()" class="fa-solid fa-compress"></i>
                                        <i v-else class="fa-solid fa-expand"></i>
                                    </button>
                                </li>
                                <li class="dropdown" v-if="haveMappedRealmRole('fauchi_support') || haveMappedRealmRole('fauchi_write_user') || haveMappedRealmRole('fauchi_treatment') || haveMappedRealmRole('fauchi_write_therapy') || haveMappedRealmRole('fauchi_choose_therapy')">
                                    <button class="nav-link text-white" :class="$route.meta.headerMenu == 'admin' ? 'on' : ''" data-bs-toggle="dropdown" role="button" aria-expanded="false"
                                        :aria-label="$t('menu.admin')">
                                        <i class="fa-solid fa-gear"></i>
                                        <span v-if="numberOfAdminMenuPendingCases" class="nav-badge">{{numberOfAdminMenuPendingCases}}</span>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li v-if="haveMappedRealmRole('fauchi_choose_therapy')" class="dropdown">
                                            <button class="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false">{{$t('menu.therapies')}}</button>
                                            <ul class="submenu dropdown-menu">
                                                <li v-for="(therapy, therapyIndex) in therapies">
                                                    <button @click="setTherapy(therapy)" class="dropdown-item"
                                                        :class="tableOfContents && therapy._id == tableOfContents._id ? 'active' : ''">
                                                        {{therapy.name}}
                                                    </button>
                                                </li>
                                            </ul>
                                        </li>
                                        <li v-if="haveMappedRealmRole('fauchi_treatment')" class="dropdown">
                                            <button class="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false" :class="$route.path.startsWith('/advice') || $route.path.startsWith('/chat') ? 'active' : ''">{{$t('menu.chats')}}
                                                <span v-if="numberOfAdminMenuChats" class="nav-badge">{{numberOfAdminMenuChats}}</span>
                                            </button>
                                            <ul class="submenu dropdown-menu">
                                                <li>
                                                    <router-link to="/advice" class="dropdown-item" :class="$route.path == '/advice' ? 'active' : ''">{{$t('menu.(chats:)advice')}}
                                                        <span v-if="numberOfPendingAdviceCases" class="nav-badge">{{numberOfPendingAdviceCases}}</span>
                                                    </router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/chat" class="dropdown-item" :class="$route.path == '/chat-course' ? 'active' : ''">{{$t('menu.(chats:)courses')}}
                                                        <span v-if="numberOfPendingChatCases" class="nav-badge">{{numberOfPendingChatCases}}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li v-if="haveMappedRealmRole('fauchi_write_therapy') || haveMappedRealmRole('fauchi_set_role')">
                                            <router-link to="/news" class="dropdown-item" :class="$route.path == '/news' ? 'active' : ''">{{$t('menu.news')}}
                                            </router-link>
                                        </li>
                                        <li v-if="haveMappedRealmRole('fauchi_support')">
                                            <router-link to="/support" class="dropdown-item" :class="$route.path == '/support' ? 'active' : ''">{{$t('menu.supportClients')}}
                                                <span v-if="numberOfPendingSupportCases" class="nav-badge">{{numberOfPendingSupportCases}}</span>
                                            </router-link>
                                        </li>
                                        <!-- FIXME: why do I have to correct position here with right/top? -->
                                        <li 
                                            v-if="haveMappedRealmRole('fauchi_write_user') || haveMappedRealmRole('fauchi_treatment')"
                                            ><router-link to="/admin-users" class="dropdown-item" :class="$route.path == '/admin-users' || $route.path.startsWith('/eval') ? 'active' : ''">{{$t('menu.usersAndCourses')}}</router-link></li>
                                        <li 
                                            v-if="authenticated && haveMappedRealmRole('fauchi_write_therapy')"
                                            ><router-link to="/admin-therapies" class="dropdown-item" :class="$route.path == '/admin-therapies' ? 'active' : ''">{{$t('menu.cms')}}</router-link></li>
                                        <li><router-link to="/admin-faq" class="dropdown-item" :class="$route.path == '/admin-faq' ? 'active' : ''">{{$t('menu.adminFaq')}}</router-link></li>
                                    </ul>
                                </li>
 
                                <li class="dropdown" v-on:keyup="clickmeIfSpaceOrEnter">
                                    <button class="nav-link text-white" :class="$route.meta.headerMenu == 'help' ? 'on' : ''" data-bs-toggle="dropdown" role="button" aria-expanded="false"
                                        :aria-label="$t('menu.help')">
                                        <i class="fa-solid fa-circle-question"></i>
                                        <span v-if="numberOfSupportMessages" class="nav-badge">{{numberOfSupportMessages}}</span>
                                    </button>
                                    <!-- used to have .text-end, but submenu looks strange with that -->
                                    <ul class="dropdown-menu">
                                        <!-- FIXME: sometimes, clicking on this doesn't close dropdown above anymore-->
                                        <li><router-link to="/support-me" class="dropdown-item" :class="$route.path == '/support-me' ? 'active' : ''">{{$t('menu.supportMe')}}
                                                <span v-if="numberOfSupportMessages" class="nav-badge">{{numberOfSupportMessages}}</span>
                                            </router-link></li>

                                        <li><router-link to="/faq" class="dropdown-item" :class="$route.path == '/faq' ? 'active' : ''">{{$t('menu.faq')}}</router-link></li>
                                        <li><button class="dropdown-item" @click="about">{{$t('menu.about')}}</button></li>
                                    </ul>
                                </li>
                                <li class="dropdown" v-on:keyup="clickmeIfSpaceOrEnter">
                                    <button class="nav-link text-white" :class="$route.meta.headerMenu == 'account' ? 'on' : ''" data-bs-toggle="dropdown" role="button" aria-expanded="false"
                                        :aria-label="$t('menu.account')">
                                        <i class="fa-solid fa-user"></i>
                                        <span v-if="numberOfAccountMenuMessages" class="nav-badge">{{numberOfAccountMenuMessages}}</span>
                                    </button>
                                    <!-- used to have .text-end, but submenu looks strange with that -->
                                    <ul class="dropdown-menu">
                                        <li v-if="enableUserProfile && loginUrl"><a class="dropdown-item" :href="loginUrl + '&kc_action=UPDATE_PROFILE'">{{$t('menu.profile')}}</a></li>
                                        <li>
                                            <button v-if="management && management.stripeCustomerId" role="button" class="dropdown-item" @click="stripeCustomerPortal">{{$t('menu.licenseOrSubscription')}}</button>
                                            <button v-else role="button" class="dropdown-item" @click="showLicense">{{$t('menu.licenseOrSubscription')}}</button>
                                        </li>
                                        <li><button role="button" class="dropdown-item" :class="tableOfContents && !tableOfContents.trial && management && management.therapy && management.therapy.currentPhase != null ? '' : 'disabled'" @click="changeGoals(false)">{{$t('menu.goals')}}</button></li>
                                        <li><router-link to="/settings" class="dropdown-item" :class="$route.path == '/settings' ? 'active' : ''">{{$t('menu.settings')}}</router-link></li>
                                        <li class="dropdown">
                                            <button class="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false" :class="$route.path.startsWith('/advice-me') || $route.path.startsWith('/chat-my-course') ? 'active' : ''">{{$t('menu.chat')}}
                                                <span v-if="numberOfChatSubMenuMessages" class="nav-badge">{{numberOfChatSubMenuMessages}}</span>
                                            </button>
                                            <ul class="submenu dropdown-menu">
                                                <li>
                                                    <router-link to="/advice-me" class="dropdown-item" 
                                                        :class="($route.path.startsWith('/advice-me') ? 'active' : '') + ' ' +
                                                                (management && management.course ? '' : 'disabled')">
                                                        {{$t('menu.(chat:)therapists')}}
                                                        <span v-if="numberOfAdviceMessages" class="nav-badge">{{numberOfAdviceMessages}}</span>
                                                    </router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/chat-my-course" class="dropdown-item" 
                                                        :class="($route.path.startsWith('/chat-my-course') ? 'active' : '') + ' ' + 
                                                                (management && management.course ? '' : 'disabled')">
                                                        {{$t('menu.(chat:)course')}}
                                                        <span v-if="numberOfChatMessages" class="nav-badge">{{numberOfChatMessages}}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li><a class="dropdown-item" href="/news-mine">{{$t('menu.news')}}
                                                <span v-if="numberOfNews" class="nav-badge">{{numberOfNews}}</span>
                                            </a>
                                        </li>

                                        <li><router-link to="/chronicle-overview" class="dropdown-item" :class="$route.path.startsWith('/chronicle') ? 'active' : ''">{{$t('menu.chronicle')}}</router-link></li>
                                        <li><button role="button" class="dropdown-item" @click="logOut()">{{$t('menu.logout')}}</button></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </header>
        <header v-else>
            <div class="kst-header fixed-top">
            <template v-if="closeable">
                <button class="btn btn-secondary btn-sm" :aria-label="$t('navigation.close')" style="position: absolute;right: 10px;/* color: white; */top: 5px;margin-top: 1px;" @click="close">{{$t('navigation.closeTab')}}</button>
            </template>
            <template v-else>
                <router-link to="/" class="blue">
                    <h3 :aria-label="$t('navigation.back')" style="color: white">
                        <i class="fa-solid fa-chevron-left"></i>
                        {{$t('menu.goToLogin')}}
                    </h3>
                </router-link>
            </template>
            </div>
        </header>

        <router-view />

        <!-- general-purpose audio element for autoplay. 
            A user interaction is required to be allowed to autoplay, and in Safari it seems
            to be per element. So we try to acquire and use the autoplay permission here
            centrally.
            See also
            - https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
            - https://rosswintle.uk/2019/01/skirting-the-ios-safari-audio-auto-play-policy-for-ui-sound-effects/
        -->
        <audio ref="audioForAutoplay" src="/zero.wav" preload="auto">
        </audio>

        <goals ref="goals" :management="management"></goals>
        <license ref="license" :management="management"></license>

        <cookiesBanner ref="cookiesBanner"></cookiesBanner>
        <cookiesOptions ref="cookiesOptions"></cookiesOptions>

        <!-- based on fauchi-prototype/login.html 
            also active for dashboard (path "/")
        -->
        <footer v-if="needsFooter"
                class="kst-footer">
            <!-- FIXME: color -->
            <a :href="$i18n.locale && $i18n.locale.startsWith('en') ? 'https://stutter-therapy.com/privacy-policy' : 'https://kasseler-stottertherapie.de/datenschutzerklaerung'" target="_blank">{{$t('footer.privacy')}}</a><!--
            strangely, have to insert this nbsp to get the same spacing as prototype
            -->&nbsp;<!--
         --><router-link to="/terms">{{$t('footer.terms')}}</router-link><!--
            -->&nbsp;<!--
         --><router-link to="/imprint">{{$t('footer.imprint')}}</router-link><!--
            -->&nbsp;<!--
         --><a :href="$i18n.locale && $i18n.locale.startsWith('en') ? 'https://stutter-therapy.com/contact' : 'https://kasseler-stottertherapie.de/kontakt'" target="_blank">{{$t('footer.contact')}}</a>
            <div class="float-sm-end pt-2 pt-sm-0">&copy; KST Institut GmbH</div>
        </footer>

    <!--
    <div ref="askPushPreference" class="modal fade" data-bs-backdrop="static" tabindex="-1">
        <div class="modal-dialog modal-sm">
            <div class="modal-content modal-alert-confirmation">
                <div class="modal-body">
                    <div class="modal-alert-message">
                        <i class="fa-solid fa-circle-question"></i>
                        <p>
                            {{$t('settings.doYouWantPushMessageOnThisDevice')}}
                        </p>
                    </div>
                    <div class="modal-alert-options">
                        <button type="button" class="btn btn-secondary" @click="neverPush()">{{$t('navigation.never')}}</button>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('navigation.notNow')}}</button>
                        <button type="button" class="btn btn-primary" @click="yesPush()">{{$t('navigation.yes')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    -->

    <div ref="missingNotificationPermission" class="modal fade" data-bs-backdrop="static" tabindex=-1>
        <div class="modal-dialog modal-sm">
            <div class="modal-content modal-alert-warning">
                <div class="modal-body">
                    <div class="modal-alert-message">
                        <i class="fa-solid fa-circle-question"></i>

                        <i18n-t keypath="dashboard.noNotificationPermission" tag="p">
                            <template v-slot:explainPushNotificationLink        >
                                <router-link target="_blank" to="/faq#grantNotificationPermission">
                                    {{$t('dashboard.explainPushNotificationLinkText')}}
                                </router-link>
                            </template>
                        </i18n-t>
                    </div>
                    <footer class="modal-footer justify-content-between align-items-end">
                        <div class="d-flex flex-column gap-2">
                            <!-- -"btn-link blue fw-600 mt-1" +"btn-secondary" -->
                            <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-dismiss="modal">{{$t('navigation.ignore')}}</button>
                            <button type="button" class="btn btn-secondary" data-bs-toggle="modal" @click="noPush">{{$t('dashboard.deactivateNotifications')}}</button>
                        </div>
                        <button type="button" class="btn btn-primary" @click="retryPush">{{$t('navigation.retry')}}</button>
                    </footer>
                </div>
            </div>
        </div>
    </div>

    <div ref="pushMessage" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-m">
            <div class="modal-content modal-padded modal-united">
                <div class="modal-header">
                    <h4 class="modal-title">{{pushMessageTitle}}</h4>
                </div>
                <div class="modal-body">
                    <p>
                        {{pushMessageBody}}
                    </p>

                </div>
                <div class="modal-footer justify-content-between" v-if="pushMessageURL && this.$route.path != pushMessageURL">
                    <button type="button" class="btn btn-secondary" @click="pushMessageClose">{{$t('navigation.close')}}</button>
                    <button type="button" class="btn btn-primary" @click="pushMessageGoToURL">{{$t('navigation.open')}}</button>
                </div>
                <div class="modal-footer justify-content-center" v-else>
                    <button type="button" class="btn btn-primary" @click="pushMessageClose">{{$t('navigation.ok')}}</button>
                </div>
            </div>
        </div>
    </div>

    <div ref="relogin" class="modal fade" data-bs-backdrop="static" tabindex="-1">
        <div class="modal-dialog modal-m">
            <div class="modal-content modal-padded modal-united">
                <div class="modal-header">
                    <h4 class="modal-title">
                        Ausgeloggt
                    </h4>
                </div>
                <div class="modal-body">
                    <p>Dein Login ist abgelaufen. Bitte logge dich erneut ein.</p>
                </div>
                <div class="modal-footer">
                    <div class="col text-end">
                        <button type="button" class="btn btn-primary" @click="loginInPopupThenClose">Ok!</button>
                    </div>
                </div>                        
            </div>
        </div>
    </div>

</template>

<script>
import {reportRequestError} from './utils/messaging.js';
import goals from './components/goals.vue';
import license from './components/license.vue';
import cookiesBanner from './components/cookies-banner.vue';
import cookiesOptions from './components/cookies-options.vue';
import {haveMappedRealmRole} from './utils/roles.js';
import {sanitizeSection} from './utils/markup';

import NotificationService from './services/notification-service';
import TherapyService from './services/therapy-service';
import {ManagementService} from "./services/management-service";
import {PaymentService} from "./services/payment-service";
import {UserService} from "./services/user-service";
import {InfoService} from "./services/info-service";
import {useMessageStore} from './stores/message-store';
import {useUploadStore} from "./stores/upload-store";
import {Modal, Toast} from "bootstrap";
import ActivityService from './services/activity-service';
import {ChannelService} from './services/channel-service';
import {CourseService} from './services/course-service';
import {MessageService} from './services/message-service';
import {JournalService} from './services/journal-service';
import {DeviceService} from './services/device-service';
import {eventBus} from "./eventBus";
import { v4 as uuidv4 } from 'uuid';
import {sleep} from "./utils/time";
import modalWarning from './components/modal-warnings.vue';
import {install} from "./plugins/keycloak";
import {getCurrentInstance} from 'vue';

export default {
    name: "app",
    components: {
        goals, license, modalWarning, cookiesBanner, cookiesOptions
    },
    setup(){
        return {
            messageStore: useMessageStore(),
            uploadStore: useUploadStore()
        }
    },
    data() {
        return {
            loading: true,
            development: import.meta.env.DEV,
            freachUrl: import.meta.env.VITE_FREACH_URL,
            numberOfSupportMessages: 0,
            numberOfAdviceMessages: 0,
            numberOfChatMessages: 0,
            numberOfPendingAdviceCases: 0,
            numberOfPendingChatCases: 0,
            numberOfPendingSupportCases: 0,
            numberOfNews: 0,
            management: null,
            tableOfContents: null,
            config: null,
            buildTime: __APP_BUILD_TIME__,
            version: __APP_VERSION__,
            sourceVersion: __SOURCE_VERSION__,
            serverStartup: '',
            serverVersion: '',
            serverSourceVersion: '',
            audioContext: null,
            device: null,
            therapies: [],
            fullScreenDummyCounter: 0,
            landscape: false,
            webPushSubscription: null,
            pushMessageTitle: null,
            pushMessageBody: null,
            pushMessageURL: null,
            pushMessagesQueue: [],
            pushMessagesBeingDisplayed: false,
            loginUrl: '',
            cookiePreferencesLookupKey: 0,
            cookiePreferencesVersion: 2,
            reloginThenCloseUrl: ''
        };
    },
    computed: {
        me(){ 
            return this.$keycloak.subject;
        },
        enableUserProfile(){
            return JSON.parse(import.meta.env.VITE_ENABLE_USER_PROFILE);
        },
        closeable() {
            return window.opener;
        },
        authenticated() {
            return this.$keycloak.authenticated &&
                this.$keycloak.realmAccess?.roles;
        },
        needsFooter(){
            return !this.authenticated || !this.$route.meta.requiresAuth || this.$route.path == '/' 
                || this.$route.path == '/dashboard'; // TODO: remove; just temporarily working around dev caches
        },
        numberOfAdminMenuPendingCases(){
            return this.numberOfPendingAdviceCases +
                this.numberOfPendingChatCases +
                this.numberOfPendingSupportCases;
        },
        numberOfAdminMenuChats(){
            return this.numberOfPendingAdviceCases +
                this.numberOfPendingChatCases;
        },
        numberOfAccountMenuMessages(){
            return this.numberOfAdviceMessages + this.numberOfChatMessages + this.numberOfNews;
        },
        numberOfChatSubMenuMessages(){
            return this.numberOfAdviceMessages + this.numberOfChatMessages;
        },
        numberOfMessages(){
            return this.numberOfAdminMenuPendingCases + this.numberOfAccountMenuMessages;
        },
        numberOfHeaderMenuEntriesPortrait(){
            return document.querySelector('.kst-header').querySelectorAll('.nav>.dropdown').length;
        },
        numberOfHeaderMenuEntriesLandscape(){
            return this.numberOfHeaderMenuEntriesPortrait +
                !!this.freachUrl + // link to freach
                1 // fullscreen button


            return document.querySelector('.kst-header').querySelectorAll('.nav>li').length;
        },
        cookiePreferencesChoices(){
            return [
                {
                    title: this.$t('privacy.basicHeader'),
                    description: this.$t('privacy.basicExplanation'),
                    items: [{label: this.$t('privacy.activeAlwaysTechnicallyNecessary'), isRequired: true, key: 'basic'}]
                },
                {
                    title: this.$t('privacy.deviceHeader'),
                    description: this.$t('privacy.deviceExplanation'),
                    items: [{label: this.$t('privacy.activeAlwaysTechnicallyNecessary'), isRequired: true, key: 'device'}]
                },
                {
                    title: this.$t('privacy.convenienceHeader'),
                    description: this.$t('privacy.convenienceExplanation'),
                    items: [{label: this.$t('privacy.active'), key: 'convenience', isEnabled: false}]
                }
            ];
        },
        cookiePreferences(){
            this.cookiePreferencesLookupKey; // mentioning causes recomputation if if updated

            const version = localStorage.getItem('cookie-preferences-version');
            if (version == null | version < this.cookiePreferencesVersion)
                return null;

            const prefs = localStorage.getItem('cookie-preferences');
            return JSON.parse(prefs);
        }
    },
    async mounted(){

        // save for later
        const {appContext} = getCurrentInstance();
        this.app = appContext.app;

        // remove outdated cookie consent
        localStorage.removeItem('cookie-comply');

        this.checkDisplayingCookieBanner();

        this.reloginThenCloseUrl = await this.$keycloak.createLoginUrl({redirectUri: window.location.origin.toString() + '/re-logged-in'});
        // hack to expose relogin
        window.relogin = this.relogin;

        const info = (await InfoService.get()).data;
        const serverVersion = info.packageVersion;
        console.log(`client version=${this.version}, server version=${serverVersion}`);

        window.addEventListener("orientationchange", this.orientationchange);
        this.landscape = this.isLandscape();

        /* updates should now be automatic, see service worker
        if (serverVersion != this.version){
            console.log(`version clash: client ${this.version} != server ${serverVersion}.`);
            if (!this.development){
                // see https://support.tmssoftware.com/t/pwa-not-auto-updating-our-solution/13886
                if ('serviceWorker' in navigator) {
                    try {
                        const registrations = await navigator.serviceWorker.getRegistrations();
                        for (let registration of registrations) 
                            await registration.update();
                    
                    } catch (err){ 
                        console.log("mounted error:", err);
                        reportRequestError(err);
                    }
                }

                debugger;

                window.location.reload(true);
            }
        }*/


        // WARNING on debugging: when the beforeunload event is fired, all debugging sessions will be discarded, even when choosing to stay on the page in the browser's confirmation dialogue. In other words, when you add a debugger statement, it prevents execution of the following code after resuming.  https://chatgpt.com/share/68ef4fee-510c-800f-b1c4-92a4f373a182
        // using window.onbeforeunload instead of window.addEventListener('beforeunload', ...) to be able to deactivate the listener e.g. in plugins/keycloak.js
        window.onbeforeunload = this.beforeUnloadListener.bind(this);

        // since the number of audio contexts is limited, we create one here centrally.
        // to use it, we still have to call resume in the context of a user gesture (https://developer.chrome.com/blog/autoplay/)
        this.audioContext = new AudioContext();

        if (this.authenticated){

            try {
                await this.$keycloak.checkTokenOrLogin();
                await this.setupUserDepending();


                if (this.$route.path == '/admin-therapy' && haveMappedRealmRole('fauchi_write_therapy')){
                    if (this.numberOfHeaderMenuEntriesPortrait > 6) // empirical estimate, depends on the icons used
                        this.messageStore.warn('Possibly too many header menu entries in portrait mode (depends on width of icons used). Check with width=360px; Or: reduce the number of books.');
                    if (this.numberOfHeaderMenuEntriesLandscape > 9) // empirical estimat, depends on the icons used
                        this.messageStore.warn('possibly too many header menu entries in landscape mode (depends on width of icons used). Check with height=640px; Or: reduce the number of books, refrain from having displayed video menu in header, or unset freachURL (backend config)');
                }
            
            } catch (err){ 
                console.log("mounted error:", err);
                reportRequestError(err);
            }
        }

        this.loading = false;


        // reload on service worker update should be triggered form within serviceworker


        if (this.authenticated){
            try {
                await this.$keycloak.checkTokenOrLogin();
                await this.checkPushNotifications();
            } catch (err){
                console.log('error checkPushNotifications:', err);
                reportRequestError(err);
            }
        }


    },
    unmounted(){
        this.audioContext.close();

        window.onbeforeunload = null;
        window.removeEventListener("orientationchange", this.orientationchange);
    },
    errorCaptured(err, vm, info){
        console.error(err);
        debugger;
        this.messageStore.warn(this.$t('errors.unknownError'));
        const propagate = false;
        return propagate;
    },
    methods: {
        close(){
            window.close();
        },
        /* create AudioContext and prepare an audio for later autoplay.
        To be called after a user gesture, see 
        https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
        https://developer.chrome.com/blog/autoplay/ */
        async unlockAutoplay(){
            if (this.audioContext)
                return;
            if (!this.$refs.audioForAutoplay.src.endsWith("zero.wav"))
                throw Error("unexpected src - make sure to call unlockAutoplay before using audioForAutoplay");
            try {
                // play now a silent dummy so we can later autoplay
                await this.$refs.audioForAutoplay.play();
                console.log("unlockAutoplay: success");
            } catch (e){
                console.log("error in unlockAutoplay: ", e);
                // makes no real sense to display a more specific message
                this.messageStore.warn(this.$t('errors.unknownError'));
            }
        },
        // TODO
        blub(){
            debugger;
        },
        async setTherapy(therapy){
            try{
                await ManagementService.setTherapy(therapy._id);
                await this.loadTableOfContents();
                setupDropdownMenus(); // from prototype's custom.js
                if (this.$route.path != "/")
                    this.$router.push('/');

            } catch (err) {
                console.log("setTherapy error:", err);
                reportRequestError(err);
            }
        },
        async setupUserDepending(){
            const user = (await UserService.get(this.me)).data;

            // hack to communicate to keycloak's profile editing form whether the user should be allowed to see and change her attribute therapyForm
            if (!user.attributes)
                user.attributes = {};
            user.attributes.therapyFormEditable = [!haveMappedRealmRole('fauchi_assignable_therapy')];
            await UserService.set(user);

            if (!localStorage.deviceId)
                await this.createDeviceSettings();
            else {
                this.device = (await DeviceService.get(this.me, localStorage.deviceId)).data;
                if (!this.device){
                   // someone deleted the settings at server?
                    console.warn('could not load device settings for deviceId' + localStorage.deviceId);
                    await this.createDeviceSettings();
                }
            }

            if (haveMappedRealmRole('fauchi_choose_therapy'))
                this.therapies = (await TherapyService.getAll(this.selectedTherapyTags, true)).data;
            await this.loadTableOfContents();

            this.loginUrl = await this.$keycloak.createLoginUrl();

            //setTimeout(() => {
            //    debugger;
                setupDropdownMenus(); // from prototype's custom.js
            //});

            this.loadNumberOfNotifications();


        },
        async createDeviceSettings(){
            const id = uuidv4();
            localStorage.deviceId = id;
            
            // delete any old settings from localStorage 
            localStorage.removeItem('wantPushNotifications');
            localStorage.removeItem('rmsLoudness');
            localStorage.removeItem('rmsLoudnesses');
            localStorage.removeItem('audioDeviceId');
            localStorage.removeItem('audioDeviceLabel');
            localStorage.removeItem('calibratedDevice');
            localStorage.removeItem('audioDeviceConfiguration');
            localStorage.removeItem('cutoffs');
            localStorage.removeItem('overriddenCutoffs');
            localStorage.removeItem('videoDeviceId');

            this.device = {
                user: this.me,
                id,
                browser: this.browser(navigator.userAgent),
                OS: this.OS(navigator.userAgent, navigator.platform)
            };
            await DeviceService.set(this.device);
        },
        about(){
            Modal.getOrCreateInstance(this.$refs.about).show();
            this.fetchServerInfo();
        },
        changeGoals(newPhase){
            this.$refs.goals.show(newPhase);
        },
        async stripeCustomerPortal(){
            const session = (await PaymentService.getCustomerPortal(this.management.stripeCustomerId)).data;
            window.open(session.url, '_blank');
        },
        showLicense(){
            this.$refs.license.show();
        },
        async fetchServerInfo(){
            this.serverSourceVersion = '';
            this.serverStartup = '';
            this.serverVersion = '';
            const result = (await InfoService.get()).data;
            this.serverSourceVersion = result.gitVersion;
            this.serverStartup = result.startupTime;
            this.serverVersion = result.packageVersion;
        },
        urlBase64ToUint8Array(base64String) {//TODO: substitute by sth standard
            const padding = "=".repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/-/g, "+")
                .replace(/_/g, "/");

            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        },
        async checkPushSubscription(){
            const registration = this.serviceWorkerRegistration;
            if (!registration)
                throw new Error("no registration?!");

            var serviceWorker = registration.installing || registration.waiting || registration.active || null;
            if (!serviceWorker)
                throw new Error("no service worker?!");

            if (serviceWorker.state != "activated"){
                // wait for it...

                const promise = new Promise(resolve => {
                    serviceWorker.addEventListener("statechange", function(e) {
                        if (e.target.state == "activated") {
                            resolve();
                        }})});
                await promise;
            }

            document.addEventListener('visibilitychange', () => {
                //console.log("visibilityState:", document.visibilityState);
                if (document.visibilityState == 'hidden')
                    serviceWorker.postMessage({type: "hidden"});
                else if (document.visibilityState == 'visible')
                    serviceWorker.postMessage({type: "visible"});
            });
            window.addEventListener('focus', () => {
                //console.log("focus");
                serviceWorker.postMessage({type: "visible"});
            });
            window.addEventListener('blur', () => {
                //console.log("blur");
                serviceWorker.postMessage({type: "hidden"});
            });
            window.addEventListener('pagehide', () => { // tab closed
                //console.log("pagehide");
                serviceWorker.postMessage({type: "hidden"});
            });

            navigator.serviceWorker.addEventListener('message', async (e) => {
                console.log("message: ", e.data);
                if (e.data.type == "incomingPushMessage"){
                    if (this.pushMessagesBeingDisplayed)
                        this.pushMessagesQueue.push(e.data);
                    else
                        this.showPushMessage(e.data);

                } else if (e.data.type == 'newMessage')
                        
                    try {
                        console.log('newMessage -> updateNotificationBadges');
                        await this.updateNotificationBadges();
                        eventBus.emit("newMessage");
                    } catch (err) {
                        console.log("error during updateNotificationBadges:", err);
                    }
            });

            serviceWorker.postMessage({type: "visible"});

            var subscription = await registration.pushManager.getSubscription();

            /*
            // this is just for testing, and can probably lead to transient 502 errors when sending from server
            if (subscription != null){ 
                await subscription.unsubscribe();
                subscription = null;
            }*/

            if (subscription == null){
                console.log("no Web Push subscription yet, subscribing");
                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: this.urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY)
                });
                await NotificationService.storeSubscription(subscription, this.device._id);
            }

            console.log("subscription:", subscription);

            // in case the user switched off push messages and then on again, we need to reactivate. If so, this is done by checkSubscription.
            const result = (await NotificationService.checkSubscription(subscription, this.device._id)).data;
            console.log("subscription status:", result);
            if (result == 'notFound' || result == 'renew'){ 
                // probably it was deleted on the server after failing to send a message. 
                // This could have happened by disallowing notifications in the browser, but not switching them off in fauchi.
                
                console.log("unsubscribing from", subscription);
                try {
                    const result = await subscription.unsubscribe();
                } catch (err) {
                    console.log("error during unsubscribe (ignoring):", err);
                }

                console.log("unsubscribe successful?", result);

                console.log("subscribing newly to Web Push");
                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: this.urlBase64ToUint8Array(import.meta.env.VITE_VAPID_PUBLIC_KEY)
                });
                await NotificationService.storeSubscription(subscription, this.device._id);
                console.log("new subscription:", subscription);
            }

            this.webPushSubscription = subscription;

        },
        clearInformation(id){
            this.messageStore.clearInformation(id);
        },
        clearSuccess(id){
            this.messageStore.clearSuccess(id);
        },
        clearWarning(id){
            this.messageStore.clearWarning(id);
        },
        clickmeIfSpaceOrEnter(e){
            if (["Space", "Enter"].includes(e.code))
                e.target.click();
        },
        performInformationAction(id){
            this.messageStore.performInformationAction(id);
        },
        performSuccessAction(id){
            this.messageStore.performSuccessAction(id);
        },
        performWarningAction(id){
            this.messageStore.performWarningAction(id);
        },
        async logOut(){

            debugger;
            try {
                await ActivityService.refresh(this.me);
            } catch (err){
                console.log('logOut: refresh error:', err);
                debugger;
            }
            debugger;

            console.log("logOut in App.vue");

            // "/" requires authorization, thus will eventually arrive at login
            const basePath = window.location.origin.toString();
            const to = "/";
            const redirectUri = basePath + to;
            this.$keycloak.logout({redirectUri});
            //this.$keycloak.keycloak.logout({'post_logout_redirect_uri': redirectUri});
            //window.location.replace("http://localhost:8082/auth/realms/testrealm/protocol/openid-connect/logout?post_logout_redirect_uri=" + encodeURIComponent(redirectUri));
            //window.location.replace("http://localhost:8082/auth/realms/testrealm/protocol/openid-connect/logout
            //await this.authStore.logout();
            //this.$router.push('/login');
        },
        async loadNumberOfNotifications(){
            try {
                if (haveMappedRealmRole('fauchi_support'))
                    this.numberOfPendingSupportCases = await this.getNumberOfPendingSupportCases();
                else
                    this.numberOfPendingSupportCases = 0;

                if (haveMappedRealmRole('fauchi_treatment')){
                    this.numberOfPendingAdviceCases = await this.getNumberOfPendingAdviceCases();
                    this.numberOfPendingChatCases = await this.getNumberOfPendingChatCases();
                } else {
                    this.numberOfPendingAdviceCases = 0;
                    this.numberOfPendingChatCases = 0;
                }

                this.numberOfSupportMessages = await this.getNumberOfSupportMessages();
                this.numberOfAdviceMessages = await this.getNumberOfAdviceMessages();
                this.numberOfChatMessages = await this.getNumberOfChatMessages();
                this.numberOfNews = await this.getNumberOfNewsMessages();

                if (navigator.setAppBadge)
                    navigator.setAppBadge(this.numberOfMessages);

                // seems strange to send this back to server, since the numbers come from there. but it just seems a good opportunity to store the value.
                JournalService.setNumberOfMessages(this.me, this.numberOfMessages);

            } catch (err) {
                console.log("loadNumberOfNotifications error:", err);
                reportRequestError(err);
            }

        },
        async checkPushNotifications(){
            if (this.device.wantPushNotifications == 'no')
                return;
            else if (this.device.wantPushNotifications == 'yes'){

                if (typeof(Notification) == "undefined"){
                    // should never get here (only in testing)
                    return;
                }

                if (Notification.permission == 'denied')
                    Modal.getOrCreateInstance(this.$refs.missingNotificationPermission).show();
                /* hm, no. At least under Firefix we cannot requestPermission unless coming from a user gesture. 
                else if (Notification.permission == 'default'){
                    //await Notification.requestPermission();
                    if (Notification.permission == 'denied')
                        Modal.getOrCreateInstance(this.$refs.missingNotificationPermission).show();
                    else if (Notification.permission == 'granted'){
                        await this.checkPushSubscription();
                        //this.sendTestNotification();
                    }
                }*/ else if (Notification.permission == 'granted'){
                    await this.checkPushSubscription();
                }
            }
        },
        async retryPush(){
            Modal.getOrCreateInstance(this.$refs.missingNotificationPermission).hide();

            if (typeof(Notification) == "undefined"){
                // should never get here (only in testing)
                return;
            }

            await Notification.requestPermission();
            this.checkPushNotifications();
        },
        async noPush(){
            this.device.wantPushNotifications = 'no';
            this.webPushSubscription = null;

            // Note: not immediately unsubscribing and removing subscription from server. This is done on purpose, should the user change her mind: Frequently (un)subscribing could cause getting delayed by push services

            try {
                await DeviceService.set(this.device);

                if (!this.serviceWorkerRegistration){
                    console.warn('noPush: no serviceWorkerRegistration?!');
                    return;
                }

                var subscription = await this.serviceWorkerRegistration.pushManager.getSubscription();
                if (subscription == null){
                    console.warn('noPush: no subscription?!');
                    return;
                }

                await NotificationService.deactivateSubscription(subscription);

            } catch (err) {
                console.log("error in noPush:", err);
            }
        },
        async yesPush(){
            this.device.wantPushNotifications = 'yes';

            if (typeof(Notification) == "undefined"){
                // should never get here (only in testing)
                return;
            }

            try {
                // directly call requestPermission, before any await, to keep user-interaction status (this is a click handler).
                const requestPromise = Notification.requestPermission();

                await DeviceService.set(this.device);

                // only after saving device, because under Edge, requestPermission can take indefinitely (just a nearly invisible bell right in the address bar)
                await requestPromise;

                /*
                if (Notification.permission == 'granted')
                    this.sendTestNotification();
                */

                this.checkPushNotifications();

            } catch (err) {
                console.log("yesPush error:", err);
                reportRequestError(err);
            }
        },
        sendTestNotification(){
            new Notification(
                "Testnachricht", {
                    body: "Glückwunsch, du hast Benachrichtigungen aktiviert und erlaubt!",
                    icon: "/img/icons/apple-touch-icon.png",
                    data: {url: "/sdf"}});
        },
        async getNumberOfPendingSupportCases(){
            // TODO: make it work without a request each time, via store, localStorage, push notifications etc.

            var res = await ChannelService.getNumberOfPendingCases('support');
            return res.data.numberOfPendingCases;
        },
        async getNumberOfPendingAdviceCases(){
            // TODO: make it work without a request each time, via store, localStorage, push notifications etc.

            var res = await ChannelService.getNumberOfPendingAdviceCases();
            return res.data.numberOfPendingCases;
        },
        async getNumberOfPendingChatCases(){
            if (!this.management)
                return 0;
            if (this.management.courseChatOff)
                return 0;

            const myCourses = (await CourseService.getMine()).data;
            if (myCourses.length == 0)
                return 0;
            const courseIds = myCourses.map(c => c._id);
            var res = await ChannelService.getNumberOfPendingCases('course', courseIds);
            return res.data.numberOfPendingCases;
        },
        async getNumberOfSupportMessages(){
            // TODO: make it work without a request each time, via store, localStorage, push notifications etc.

            const supportChannel = (await ChannelService.getFromDefinitionOrDefine(
                    'support', this.me, '', '', '', true)).data;
            if (!supportChannel)
               return 0;

            const numberOfMessages = (await MessageService.getNumberOfUnreadMessages([supportChannel._id])).data;
            return numberOfMessages;
        },
        async getNumberOfAdviceMessages(){
            const adviceChannel = (await ChannelService.getFromDefinitionOrDefine(
                'advice', this.me, '', '', '', true)).data;
             if (!adviceChannel)
                 return 0;
            const numberOfMessages = (await MessageService.getNumberOfUnreadMessages([adviceChannel._id])).data;
            return numberOfMessages;
        },
        async getNumberOfChatMessages(){
            if (!this.management)
                return 0;
            if (this.management.courseChatOff)
                return 0;

            if (!this.management.course)
                return 0;

            const courseChannel = (await ChannelService.getFromDefinitionOrDefine(
                'course', '', this.management.course._id, '', '', true)).data;
             if (!courseChannel)
                 return 0;
            const numberOfMessages = (await MessageService.getNumberOfUnreadMessages([courseChannel._id])).data;
            return numberOfMessages;

        },
        async getNumberOfNewsMessages(){
            if (!this.management)
                return 0;
            const channels = [];
            if (this.management.effectiveTherapy){
                const therapyId = this.management.effectiveTherapy._id;
                const therapyChannel = (await ChannelService.getFromDefinitionOrDefine(
                    'therapy', '', '', therapyId, '', true)).data;

                if (therapyChannel)
                    channels.push(therapyChannel);
            }

            // a nuisance for coding, but (hopefully) a service for users: display messages of both therapy news and role(s) news
            const roles = (await UserService.getUserRoles(this.me)).data;
            for (const role of roles){
                const roleChannel = (await ChannelService.getFromDefinitionOrDefine(
                    'role', '', '', '', role.name, true)).data;
                channels.push(roleChannel);
            }

            const numberOfMessages = (await MessageService.getNumberOfUnreadMessages(channels.map(c => c._id))).data;
            return numberOfMessages;
        },

        async getEffectiveTherapy(){
            this.management = (await ManagementService.getForMeGuestTherapySafe()).data;
            return this.management.effectiveTherapy;
        },
        async loadTableOfContents(){
            // TODO: probably load me at some central point
            // TODO: let's say if we load it in app, it's central enough...

            const therapy = await this.getEffectiveTherapy();
            if (!therapy){
                if (haveMappedRealmRole('fauchi_assignable_therapy')
                    && haveMappedRealmRole('fauchi_assignable_course'))
                    this.messageStore.warn(this.$t('errors.noTherapy'));
                
                return;
            }

            try {
                this.tableOfContents = (await TherapyService.getTableOfContents(therapy._id)).data;
            } catch (err){
                console.log("loadTableOfContents error:", err);
                reportRequestError(err);
            }
        },
        updateNotificationBadges(){
            this.loadNumberOfNotifications();
        },
        beforeUnloadListener(e){
            if (this.uploadStore.anything){
                console.log("beforeUnloadListener app");
                e.preventDefault();

                // important to set a value here, even if browser may not display the actual text
                return e.returnValue = "Are you sure you want to exit?";

            }
        },
        haveMappedRealmRole(fauchiRole){
            return haveMappedRealmRole(fauchiRole);
        },
        async toggleFullScreen() {
            // https://stackoverflow.com/a/29282102
            if (!this.isFullScreen()){
                if (document.documentElement.requestFullscreen) {
                    await document.documentElement.requestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) {
                    await document.documentElement.msRequestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    await document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    await document.documentElement.webkitRequestFullscreen(document.documentElement.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.exitFullscreen) {
                    await document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    await document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    await document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    await document.webkitExitFullscreen();
                }
            }
            // force recomputation. 'await' above is important for this to work correctly.
            this.fullScreenDummyCounter++;
        },
        isFullScreen(){
            // force recomputation if necessary; referencing suffices
            this.fullScreenDummyCounter;

            const result = !!(document.fullscreenElement ||    // alternative standard method
                document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement );  // current working methods
            console.log('isFullScreen', result);
            return result;
        },
        isLandscape(){
            return window.matchMedia("(orientation: landscape)").matches;
        },
        orientationchange(){
            this.landscape = !this.landscape;
        },
        showPushMessage(data){
            this.pushMessageTitle = data.title;
            this.pushMessageBody = data.content;
            this.pushMessageURL = data.url;
            Modal.getOrCreateInstance(this.$refs.pushMessage).show();
            this.pushMessagesBeingDisplayed = true;
        },
        pushMessageClose(){
            Modal.getOrCreateInstance(this.$refs.pushMessage).hide();

            if (this.pushMessagesQueue.length == 0){
                this.pushMessagesBeingDisplayed = false;
                return;
            }

            setTimeout(() => {
                const data = this.pushMessagesQueue.splice(0, 1)[0];
                this.showPushMessage(data);
            }, 1000);
        },
        pushMessageGoToURL(){
            this.pushMessageClose();
            this.$router.push(this.pushMessageURL);
        },
        sanitizeSection(html){
            return sanitizeSection(html);
        },
        showCookieOptions(){
            Modal.getOrCreateInstance(this.$refs.cookiesOptions.$refs.cookiesOptions).show();
        },
        acceptAllCookies(){
            const all = this.cookiePreferencesChoices.map(p => p.items).flat().map(i => i.key)
            localStorage.setItem('cookie-preferences', 
                JSON.stringify(all));

            localStorage.setItem('cookie-preferences-version', this.cookiePreferencesVersion);
            this.cookiePreferencesLookupKey++;

            this.onUpdateCookiePreferences();
        },
        setCookiePreferences(optional){
            const required = this.cookiePreferencesChoices.map(p => p.items).flat().filter(i => i.isRequired).map(i => i.key);
            const both = [...optional, ...required];

            localStorage.setItem('cookie-preferences', JSON.stringify(both));
            localStorage.setItem('cookie-preferences-version', this.cookiePreferencesVersion);
            this.cookiePreferencesLookupKey++;

            this.onUpdateCookiePreferences();
        },
        toggleCookiePreference(){
        },
        async onUpdateCookiePreferences(){
            if (this.device.videoDeviceId && !this.cookiePreferences.includes('convenience')){
                this.device.videoDeviceId = null;
                await DeviceService.set(this.device);
            }
        },
        browser(userAgent){
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Browser_detection_using_the_user_agent
            if (userAgent.includes('Firefox/') && !userAgent.includes('Seamonkey/'))
                return 'Firefox';
            if (userAgent.includes('Seamonkey/'))
                return 'Seamonkey';
            if (userAgent.includes('Chrome/') && !userAgent.includes('Chromium/') && !/Edg.*\/xyz/.test(userAgent))
                return 'Chrome';
            if (userAgent.includes('Chromium/'))
                return 'Chromium';
            if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/') && !userAgent.includes('Chromium'))
                return 'Safari';
            if (userAgent.includes('OPR/') || userAgent.includes('Opera/'))
                return 'Opera';
            return this.$t('settings.unknownBrowser');
        },
        OS(userAgent, platform){
            if (/win/i.test(platform)) return "Windows";
            if (/mac/i.test(platform)) return "MacOS";
            if (/linux/i.test(platform)) return "Linux";
            if (/android/i.test(userAgent)) return "Android";
            if (/iphone|ipad|ipod/i.test(userAgent)) return "iOS";
            return this.$t('settings.unknownOS');
        },
        checkDisplayingCookieBanner(){
            if (this.cookiePreferences == null){
                Toast.getOrCreateInstance(this.$refs.cookiesBanner.$refs.cookiesBanner).show();
            }
        },
        async testRelogin(){
            await this.relogin();
            console.log("hi");
            console.log("hu");
        },
        async relogin(){
            let {promise, resolve, reject} = Promise.withResolvers();
            this.reloginResolve = resolve;

            // we need a user gesture to be allowed to open the login window. So we display a modal with a button.
            Modal.getOrCreateInstance(this.$refs.relogin).show();

            return promise;
        },
        loginInPopupThenClose(){
            window.addEventListener("message", 
                async (event) => {
                    console.log("message from child: logged in");
                    if (event.data.type == 're-logged-in'){
                        Modal.getOrCreateInstance(this.$refs.relogin).hide();

                        // sometimes, the closing (see re-logged-in in main.js) doesn't work. This is supposed to fix those cases:
                        try {
                            this.reloginWindow?.close();
                        } catch (err){
                            console.warn("loginInPopupThenClose: error trying to close:", err);
                        }

                        // re-init keycloak!
                        install(this.app);
                        const isAuthenticated = await this.$keycloak.init({
                            token: event.data.token,
                            refreshToken: event.data.refreshToken,
                            checkLoginIframe: false});

                        this.reloginResolve();
                    }
                }, 
                {once: true} // remove immediately after usage)
            );

            //window.open(this.reloginThenCloseUrl, '_blank', "popup=true,width=370,height=100");
            this.reloginWindow = window.open(this.reloginThenCloseUrl, '_blank');
        }
    }/*,
    async updated(){
        if (this.currentUser && !this.userDependingIsSetup){
            try {
                await this.setupUserDepending();
            } catch (err){
                console.log("updated error:", err);
                reportRequestError(err);
            }
            this.userDependingIsSetup = true;
        }
    }
    */
};
</script>

